(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import PropTypes from 'prop-types';
import styled from 'styled-components';
import Flex from "./Flex.js";
var Row = styled(Flex).withConfig({
  displayName: "Row",
  componentId: "sc-1ep010t-0"
})(["width:100%;flex-direction:row;align-items:", ";justify-content:", ";&:last-child{margin:0;}"], function (props) {
  switch (props.vertical) {
    case 'top':
      return 'flex-start';

    case 'bottom':
      return 'flex-end';

    case 'stretch':
    case 'center':
      return props.vertical;

    default:
      return 'stretch';
  }
}, function (props) {
  switch (props.horizontal) {
    case 'start':
      return 'flex-start';

    case 'end':
      return 'flex-end';

    case 'center':
    case 'space-between':
      return props.horizontal;

    default:
      return 'flex-start';
  }
});
Row.propTypes = {
  horizontal: PropTypes.string,
  vertical: PropTypes.string
};
var _default = Row;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Row, "Row", "/home/vsts/work/1/s/src/components/layout/Row.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/layout/Row.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();